import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to the top on every route change. Without this, navigating
 * from a scrolled page (e.g. /checkout) to a new route (e.g. /eft/:id) keeps the
 * previous scroll offset, so the new page opens part-way down.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
